import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MailService } from '@ascschool/services/mail/mail.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']
})
export class PopupTagComponent implements OnInit {
  @ViewChildren("label") labelElement: any;
  @Input() value: any;
  validateForm: FormGroup;
  mode: string;
  constructor(
    private fb: FormBuilder,
    private modal: NzModalRef,
    private service: MailService,
    private msg: NzMessageService,
    public utilsService: UtilsService,
  ) { 
    this.validateForm = this.fb.group({
      id: this.fb.control(0),
      name: this.fb.control('', Validators.required),
      color: this.fb.control(''),
    });
  }
  colors = ['#b2102f','#f73378','#2979ff','#007bb2','#00a0b2','#76ff03','#00e676','#ffea00','#ffc400'];
  close(){
    this.modal.destroy();
  }
  add(){
    this.submit();
    if(this.validateForm.valid){
      this.service.addTag(this.validateForm.value).subscribe(
        () => {
          this.msg.success('Tạo nhãn thành công!');
          this.modal.destroy(true);
        },()=>{
          this.msg.error('Tạo nhãn thất bại vui lòng thử lại.');
        });
    }else{
      this.utilsService.showNotifyInvalidControls(this.validateForm,this.labelElement);
    }

  }
  edit(){
    this.submit();
    if(this.validateForm.valid){
      this.service.editTag(this.validateForm.value).subscribe(
        () => {
          this.msg.success('Sửa nhãn thành công!');
          this.modal.destroy(true);
        },()=>{
          this.msg.error('Sửa nhãn thất bại vui lòng thử lại.');
        })
    }else{
      this.utilsService.showNotifyInvalidControls(this.validateForm,this.labelElement);
    }
  }
  submit(){
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
  }
  checkMode(){
    if(this.value === null){
      this.mode = 'add';
    }else{
      this.mode = 'edit';
      this.validateForm.controls.id.setValue(this.value.id);
      this.validateForm.controls.name.setValue(this.value.name);
      this.validateForm.controls.color.setValue(this.value.color);
    }
  }
  ngOnInit() {
    this.checkMode();
  }
}
